import React from 'react'

export const TeacherSettingsLeaderboardConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/settings/leaderboard',
            component: React.lazy(() => import('./TeacherSettingsLeaderboard')),
            applicationPath: 'TeacherSettingsLeaderboard',
        },
    ]
}